import { memo } from "react";

import Typography from "@mui/material/Typography";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingNameRow = memo(function OrganizationFindingNameRow({
  name,
}: OrganizationFindingNameRowProps): JSX.Element {
  return (
    <Abstract label="Name">
      <Typography variant="body1" sx={{ wordBreak: "break-word" }}>
        {name}
      </Typography>
    </Abstract>
  );
});

export default OrganizationFindingNameRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingNameRowProps {
  name: string;
}
